export default __webpack_public_path__ + "static/media/dsv-amazon-standard.81163acd.svg";